import { z } from 'zod';

// CSP script-src 'self'를 유지한다. 스키마 정의 전에 동적 Function 생성/탐색을 끈다.
// 같은 Zod schema·refinement·strict 입력 검증을 일반 파서로 실행한다.
z.config({ jitless: true });
